export const runtimeURL='/assets/coldchain/runtime-config.json'; export const manifestURL='/assets/coldchain/asset-manifest.json';